import React, { useState, useEffect } from "react";
import { setAutoPlayToggle, getAutoPlayToggle } from "../../Utils/Common";
import axios from "axios";
import { useParams } from "react-router-dom";
import { ResponseMessage } from "../../components/messages/response-message";
import "./book-read.css";

function SampleRead() {
  const autoPlayToggleValue = getAutoPlayToggle();
  const [error, setError] = useState([]);
  const [loader, setLoader] = useState(true);
  const [status, setStatus] = useState("");
  const [message, setMessage] = useState("");
  const [translation, setTranslation] = useState([]);
  const [autoPlayFeature, setAutoPlayFeature] = useState(autoPlayToggleValue);
  const [book, setBook] = useState({});
  const [phraseNo, setPhraseNo] = useState("");
  const [isMount, setIsMount] = useState(true);
  const { book_code } = useParams();

  useEffect(() => {
    if (isMount === true) {
      const axiosOptions = {
        url: `${process.env.REACT_APP_API_URL}v1/guest/sample-chapter?book_code=${book_code}&phrase_no=${phraseNo}`,
        method: "get",
        headers: {
          Accept: "application/json",
        },
      };
      axios(axiosOptions)
        .then((response) => {
          console.log(response.data.data);
          if (response.status === 200) {
            // translate(response.data.data.word_list);
            // setTranslation(response.data.data.translated_text.translations);
            setBook(response.data.data);
            setIsMount(false);
            loadAudio(response.data.data.line_audio);
            setStatus(response.status);
            // translate(response.data.data.word_list);
          }
        })
        .catch((error) => {
          setLoader(false);
          console.log(error.response);
          setStatus(error.response.status);
          setMessage(error.response.data.message);
        })
        .then(function () {
          // always executed
          setLoader(false);
        });
    }
  }, [isMount]);

  const handleNextPreviousClick = (value) => {
    // console.log("clicked");
    if (value !== null) {
      setLoader(true);
      setPhraseNo(value);

      var sourceOgg = document.getElementById("player");
      var sourceMp3 = document.getElementById("player");
      sourceOgg.src = "";
      sourceMp3.src = "";

      setIsMount(true);
    }
  };

  const loadAudio = (line_audio) => {
    var player = document.getElementById("player");
    var sourceOgg = document.getElementById("player");
    var sourceMp3 = document.getElementById("player");

    sourceOgg.src = line_audio;
    sourceMp3.src = line_audio;

    player.load(); //just start buffering (preload)
    // player.play(); // comment because we want user start playing
  };

  // const translate = (textList) => {
  //   var formData = new FormData();
  //   textList.map((text, index) => {
  //     formData.append("text[]", text);
  //   });

  //   setTranslation([]);

  //   axios({
  //     method: "post",
  //     url: `${process.env.REACT_APP_API_URL}v1/guest/text-translate`,
  //     headers: {
  //       Accept: "application/json",
  //     },
  //     data: formData,
  //   })
  //     .then((response) => {
  //       if (response.status === 200) {
  //         setStatus(200);
  //         setMessage(response.data.message);
  //         setTranslation(response.data.data.translations);
  //         console.log("trans", response.data.data);
  //       }
  //     })
  //     .catch((error) => {
  //       if (error.response.status === 422) {
  //         setError(error.response.data.message);
  //         setStatus(422);
  //         setMessage(error.response.data.message);
  //       } else if (error.response.status === 500) {
  //         setStatus(500);
  //         setMessage("Something went wrong. Please try again later.");
  //       } else if (error.response.status === 401) {
  //         setStatus(401);
  //         setMessage("Something went wrong. Please try again later.");
  //       } else {
  //         setStatus(500);
  //         setMessage("Something went wrong. Please try again later.");
  //       }
  //     });
  // };

  const autoPlayHandle = (value) => {
    setAutoPlayToggle(value);
    setAutoPlayFeature(value);
  };

  return (
    <div className="card mb-5 mb-xl-8" style={{ marginTop: "140px" }}>
      <div className="container-xxl" id="kt_content_container">
        <div style={{ textAlign: "center", fontSize: "50px" }}>
          {/* Sample Chapter Phrase */}
          {/* <hr /> */}
        </div>
        <div className="card-body pt-9 pb-0 text-center">
          <div className="d-flex justify-content-center">
            <div
              className={loader === true ? "spinner-border" : ""}
              role="status"
            >
              <span className="visually-hidden">Loading...</span>
            </div>
          </div>
          {Object.entries(book).length > 0 ? (
            <div className="row">
              <div className="col-2"></div>
              <div className="col-8">
                <div className="row">
                  <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                    <h1 style={{ color: "black", padding: "15px 0 25px" }}>
                      {/* Phrase {book.phrase_no} : Chapter {book.chapter.title} */}
                      Chapter {book.chapter.title}
                    </h1>{" "}
                    {/* <p style={{ fontSize: "30px" }}> {book.book.title} </p>{" "} */}
                  </div>
                </div>

                <div className="progress">
                  <div
                    className="progress-bar"
                    role="progressbar"
                    style={{
                      width: `${
                        (book.read_sample_phrases / book.total_sample_phrases) *
                        100
                      }%`,
                    }}
                    aria-valuenow={book.read_sample_phrases}
                    aria-valuemin="0"
                    aria-valuemax={book.total_sample_phrases}
                  ></div>
                </div>
                <div className="text-end fs-1">
                  {book.read_sample_phrases}/{book.total_sample_phrases}
                  {/* {5}/{10} */}
                </div>

                <div className="row" style={{ marginTop: "50px" }}>
                  <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                    {/* <h1>Phrase {book.phrase_no}: </h1> */}

                    <div className="row">
                      <div className="col-2 text-end">
                        {book.previous_phrase_no !== null ? (
                          <>
                            {/* <i
                              className="bi bi-volume-up text-dark fs-5hx"
                              style={{ marginRight: "10px" }}
                            ></i> */}
                            <i
                              className="bi bi-skip-start text-dark fs-5hx"
                              onClick={() =>
                                handleNextPreviousClick(book.previous_phrase_no)
                              }
                            ></i>
                            {/* <i
                              className="bi bi-volume-up text-dark fs-5hx"
                              style={{ marginRight: "10px" }}
                            ></i> */}
                          </>
                        ) : (
                          <>
                            {/* <i
                              className="bi bi-volume-up text-dark fs-5hx"
                              style={{ marginRight: "10px" }}
                            ></i> */}
                            <i
                              className="bi disabled bi-skip-start text-dark fs-5hx"
                              onClick={() =>
                                handleNextPreviousClick(book.previous_phrase_no)
                              }
                            ></i>
                            {/* <i
                              className="bi bi-volume-up text-dark fs-5hx"
                              style={{ marginRight: "10px" }}
                            ></i> */}
                          </>
                        )}
                      </div>

                      <div
                        className="col-8 text-start"
                        style={{ margin: "auto" }}
                      >
                        {/* <i
                          className="bi bi-volume-up text-dark fs-5hx"
                          style={{ marginRight: "10px", float: "left" }}
                        ></i> */}
                        <p
                          className="line-translation"
                          // onMouseOver={() => translate()}
                        >
                          {/* <img
                            src="/images/speaker.png"
                            alt="speaker"
                            style={{ marginRight: "10px" }}
                          /> */}

                          {book.word_list.map((word, index) => (
                            <span
                              data-bs-toggle="tooltip"
                              data-bs-placement="top"
                              key={index}
                              // onMouseOver={() => translate(word)}
                              // translated_text.translations
                              // title={
                              //   translation.length > 0
                              //     ? translation[index].translatedText
                              //     : null
                              // }
                              title={
                                book.translated_status == 1
                                  ? book.translated_text.translations[index]
                                      .translatedText
                                  : book.translated_message
                              }
                            >
                              <span className="dot-under-text">
                                {word + " "}
                              </span>
                            </span>
                          ))}

                          {/* {book.phrase} */}
                        </p>
                      </div>

                      <div className="col-2 text-start">
                        {book.next_phrase_no !== null ? (
                          <i
                            className="bi bi-skip-end text-dark fs-5hx"
                            onClick={() =>
                              handleNextPreviousClick(book.next_phrase_no)
                            }
                          ></i>
                        ) : (
                          <i
                            className="bi disabled bi-skip-end text-dark fs-5hx"
                            onClick={() =>
                              handleNextPreviousClick(book.next_phrase_no)
                            }
                          ></i>
                        )}
                      </div>
                    </div>
                  </div>
                </div>

                <div className="row" style={{ marginTop: "20px" }}>
                  <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                    {/* <h1> {book.dictionary} </h1> */}
                  </div>
                </div>

                <div className="row" style={{ marginTop: "30px" }}>
                  <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                    {book.line_audio !== undefined ? (
                      <audio
                        controls
                        autoPlay
                        className="w-250px"
                        onEnded={() =>
                          autoPlayFeature === "true"
                            ? handleNextPreviousClick(book.next_phrase_no)
                            : null
                        }
                        id="player"
                      >
                        <source src="" type="audio/ogg" />

                        <source src="" type="audio/mpeg" />
                      </audio>
                    ) : null}
                  </div>
                  <div className="text-center mt-7">AutoPlay</div>

                  {autoPlayFeature === "true" ? (
                    <i
                      className="bi bi-play-circle-fill fs-3hx text-black"
                      role="button"
                      onClick={() => autoPlayHandle("false")}
                    ></i>
                  ) : (
                    <i
                      className="bi bi-play-circle fs-3hx text-black"
                      role="button"
                      onClick={() => autoPlayHandle("true")}
                    ></i>
                  )}
                </div>
              </div>
              <div className="col-2 col-sm-2 col-md-2 col-lg-2 col-xl-2"></div>
            </div>
          ) : (
            <div
              style={{ textAlign: "center", color: "red", fontSize: "20px" }}
              className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12"
            >
              <ResponseMessage status={status} message={message} />
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default SampleRead;
